<div class="download-image">
  <a (click)="downloadImage($event)" ngbTooltip="Export image" placement="top" data-testid="icon-export-image">
    @if (!useDownloadIcon) {
      <grid-ui-icon class="icon" name="png"></grid-ui-icon>
    }
    @if (useDownloadIcon) {
      <grid-ui-icon class="icon xs" name="download"></grid-ui-icon>
    }
  </a>
</div>

<div class="offscreen" tabindex="-1">
  <div #legend class="legend-container">
    <grid-ui-global-legend-expanded></grid-ui-global-legend-expanded>
  </div>
  <div #offscreenclone [ngStyle]="optionalStyle"></div>
</div>
